export default __webpack_public_path__ + "static/media/21.24fe8c45.jpg";